import React from "react";
import { startGoogleLogin } from "@/context/AuthContext";

export default function GoogleButton({ label = "Continue with Google" }) {
  return (
    <button
      type="button"
      data-testid="google-login-btn"
      onClick={startGoogleLogin}
      className="w-full bg-white border border-[#0a2540] font-semibold py-3 flex items-center justify-center gap-3 hover:bg-[#0a2540] hover:text-white transition-colors"
    >
      <svg width="18" height="18" viewBox="0 0 48 48" className="shrink-0">
        <path fill="#FFC107" d="M43.6 20.5H42V20H24v8h11.3C33.7 32.9 29.3 36 24 36c-6.6 0-12-5.4-12-12s5.4-12 12-12c3.1 0 5.9 1.2 8 3.1l5.7-5.7C34.5 6.5 29.5 4.5 24 4.5 13.2 4.5 4.5 13.2 4.5 24S13.2 43.5 24 43.5 43.5 34.8 43.5 24c0-1.2-.1-2.3-.4-3.5z" />
        <path fill="#FF3D00" d="M6.3 14.7l6.6 4.8C14.7 15.1 19 12 24 12c3.1 0 5.9 1.2 8 3.1l5.7-5.7C34.5 6.5 29.5 4.5 24 4.5c-7.7 0-14.3 4.4-17.7 10.2z" />
        <path fill="#4CAF50" d="M24 43.5c5.4 0 10.3-2.1 14-5.4l-6.5-5.5c-2 1.5-4.6 2.4-7.5 2.4-5.3 0-9.7-3.1-11.3-7.6l-6.5 5C9.7 39.1 16.3 43.5 24 43.5z" />
        <path fill="#1976D2" d="M43.6 20.5H42V20H24v8h11.3c-.8 2.2-2.2 4-4 5.3l6.5 5.5C41.3 36 43.5 30.6 43.5 24c0-1.2-.1-2.3-.4-3.5z" />
      </svg>
      {label}
    </button>
  );
}
